import { Stack, Sheet } from "@financeable-com-au/financeable-ui";

const ErrorFrame = () => {
  return (
    <Sheet borderRadius="lg" borderWidth="md" color="neutral" variant="outlined" padding={0}>
      <Stack alignItems="center" justifyContent="center" height="100vh" rowGap={2}>
        <span>Unfortunately, we could not cast the application.</span>
      </Stack>
    </Sheet>
  );
};

export { ErrorFrame };
